/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Grid,
  CircularProgress,
  TextField,
  Tooltip,
  Card,
  CardContent,
  Typography,
  Chip,
  IconButton,
  Divider,
  Alert,
  AlertTitle,
} from "@mui/material";
import {
  Print as PrintIcon,
  Download as DownloadIcon,
  FilterList as FilterIcon,
  School as SchoolIcon,
  People as PeopleIcon,
  AttachMoney as MoneyIcon,
  TrendingUp as TrendingUpIcon,
  Assessment as ReportIcon,
} from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useTranslation } from "react-i18next";
import i18n from "../../i18";
import Nursery from "../Images/Nursery.png";
import PrimaryShool from "../Images/PrimaryShool.png";
import SecondarySchool from "../Images/SecondarySchool.png";

const GetStudentReport = () => {
  const { t } = useTranslation();
  const [dataSource, setDataSource] = React.useState([]);
  const [classFilter, setClassFilter] = React.useState("all");
  const [sectionFilter, setSectionFilter] = React.useState("all");
  const [minPaid, setMinPaid] = React.useState("");
  const [maxPaid, setMaxPaid] = React.useState("");
  const [filteredData, setFilteredData] = React.useState([]);
  const token = localStorage.getItem("token");
  const [loading, setLoading] = React.useState(true);
  const [selectedImage, setSelectedImage] = React.useState(Nursery);
  const [showFilters, setShowFilters] = React.useState(false);
  const user = JSON.parse(localStorage.getItem("user"));

  React.useEffect(() => {
    const loadUserData = () => {
      const branchId = user?.branch_id || 2;
      const branchImages = {
        1: Nursery,
        2: PrimaryShool,
        3: SecondarySchool,
      };
      setSelectedImage(branchImages[branchId] || Nursery);
    };

    loadUserData();
  }, [user]);
  const branchTitleMap = {
    1: "باخچەی منداڵانی کلیڤەری ناحکومی",
    2: "ناوەندیی کلیڤەری ناحکومی",
    3: "ئامادەی کلیڤەری ناحکومی",
  };
  const branchTitle = branchTitleMap[user?.branch_id] || "قوتابخانەی کلیڤەری بنەڕەتی ناحکومی";
  const isRTL = i18n.language === 'ar' || i18n.language === 'ku';
  const printStyles = `
@media print {
     * {
        font-size: 24px !important;
      }
      
     html, body, div, span, table, tr, td, th, p, h1, h2, h3, h4, h5, h6 {
        font-size: 24px !important;
      }
      
     body, html {
        width: 100% !important;
        height: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        font-size: 24px !important;
        line-height: 1.5 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        background-color: white !important;
        direction: ${isRTL ? 'rtl' : 'ltr'} !important;
        text-align: ${isRTL ? 'right' : 'left'} !important;
      }

    body * {
      visibility: hidden;
      font-size: 24px !important;
    }

    .print-container, .print-container * {
      visibility: visible;
      background-color: white !important;
      font-size: 24px !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
      text-align: ${isRTL ? 'right' : 'left'} !important;
    }

    .print-container {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: auto;
      padding: 0;
      margin: 0;
    }

    .print-header {
      display: block !important;
      text-align: ${isRTL ? 'right' : 'center'};
      margin-bottom: 20px;
      page-break-after: avoid;
      font-size: 20px !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }

    .no-print {
      display: none !important;
    }

    .table-container {
      width: 100% !important;
      margin: 0 !important;
      overflow: visible !important;
      page-break-inside: auto;
    }

    table {
      width: 100% !important;
      border-collapse: separate !important;
      border-spacing: 0 !important;
      font-size: 24px !important;
      border: none !important;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
      border-radius: 8px !important;
      overflow: hidden !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }

    th {
      background: #000080 !important;
      color: #ffffff !important;
      font-weight: 700 !important;
      font-size: 20px !important;
      text-align: ${isRTL ? 'right' : 'center'} !important;
      text-transform: uppercase !important;
      letter-spacing: 0.8px !important;
      border-bottom: 2px solid #dee2e6 !important;
      position: relative !important;
    }
    th, th * {
      background: #000080 !important;
      color: #ffffff !important;
      font-size: 20px !important;
    }
    th:first-child {
      border-top-left-radius: 8px !important;
    }
    th:last-child {
      border-top-right-radius: 8px !important;
    }
    thead {
      display: table-header-group !important;
    }
    tbody tr:nth-child(even) {
      background-color: #fafbfc !important;
    }
    tbody tr:nth-child(odd) {
      background-color: white !important;
    }
    tbody tr:hover {
      background-color: #f8f9fa !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08) !important;
    }
    .total-row {
      background: #ffffff !important;
      color: #2c3e50 !important;
      font-weight: 700 !important;
      border-top: 3px solid #2196f3 !important;
      border-bottom: none !important;
      position: relative !important;
    }
    .total-row::before {
      content: '' !important;
      position: absolute !important;
      top: 0 !important;
      left: 0 !important;
      right: 0 !important;
      height: 3px !important;
      background: linear-gradient(90deg, #2196f3 0%, #1976d2 100%) !important;
    }
    .total-row td {
      background: transparent !important;
      color: #2c3e50 !important;
      font-weight: 700 !important;
      font-size: 24px !important;
      border: none !important;
      border-top: 3px solid #2196f3 !important;
      padding: 20px !important;
      text-align: ${isRTL ? 'right' : 'left'} !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }
    .total-row td:first-child {
      border-bottom-left-radius: 8px !important;
    }
    .total-row td:last-child {
      border-bottom-right-radius: 8px !important;
    }
    @page {
      size: A4;
      margin: 8mm;
    }
    .print-container th,
    .print-container th * {
      font-size: 20px !important;
      background: #000080 !important;
      color: #ffffff !important;
    }
    .print-container td,
    .print-container td * {
      font-size: 24px !important;
    }
    .print-container table {
      font-size: 24px !important;
    }
    .print-container table td {
      font-size: 24px !important;
    }
    .print-container table th {
      font-size: 20px !important;
    }

    tr {
      page-break-inside: avoid;
      page-break-after: auto;
    }

    td, th {
      padding: 16px 20px !important;
      border: none !important;
      font-size: 24px !important;
      text-align: ${isRTL ? 'right' : 'left'} !important;
      vertical-align: middle !important;
      border-bottom: 1px solid #f0f0f0 !important;
      direction: ${isRTL ? 'rtl' : 'ltr'} !important;
    }
    td {
      font-size: 24px !important;
    }
    .print-container td, .print-container th {
      font-size: 24px !important;
    }
    .print-container th {
      font-size: 20px !important;
    }
  }

  .print-header {
    display: none;
  }
`;

  const handlePrint = () => {
    const originalStyles = document.body.style.cssText;
    document.body.style.cssText = "height: auto; overflow: visible;";
    window.print();
    setTimeout(() => {
      document.body.style.cssText = originalStyles;
    }, 1000);
  };

  React.useEffect(() => {
    getApiProducts();
  }, [token]);

  React.useEffect(() => {
    applyFilters();
  }, [classFilter, sectionFilter, minPaid, maxPaid, dataSource]);

  const getApiProducts = async () => {
    try {
      const res = await fetch(
        "https://api.clever-school.com/api/reports/students-report",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);

      const responseData = await res.json();
      if (Array.isArray(responseData)) {
        setDataSource(responseData);
        setFilteredData(responseData);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setDataSource([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = dataSource.filter((student) => {
      const matchesClass =
        classFilter === "all" || JSON.parse(student.class).en === classFilter;
      const matchesSection =
        sectionFilter === "all" ||
        JSON.parse(student.section).en === sectionFilter;
      const paid = parseFloat(student.total_paid || 0);

      return (
        matchesClass &&
        matchesSection &&
        (minPaid === "" || paid >= minPaid) &&
        (maxPaid === "" || paid <= maxPaid)
      );
    });

    setFilteredData(filtered);
  };

  const totals = filteredData.reduce(
    (acc, row) => ({
      tuitionFee: acc.tuitionFee + parseFloat(row.tuition_fee || 0),
      tuitionDiscount:
        acc.tuitionDiscount + parseFloat(row.tuition_discount || 0),
      totalPaid: acc.totalPaid + parseFloat(row.total_paid || 0),
      totalRemaining: acc.totalRemaining + parseFloat(row.total_remaining || 0),
    }),
    {
      tuitionFee: 0,
      tuitionDiscount: 0,
      totalPaid: 0,
      totalRemaining: 0,
    }
  );

  const columns = [
    {
      title: "#",
      render: (_, __, index) => index + 1,
      width: "60px",
      align: "center",
    },
    { 
      title: t("name"), 
      dataIndex: "name",
      width: "150px",
      align: "left",
    },
    {
      title: t("class"),
      dataIndex: "class",
      render: (text) => {
        try {
          return JSON.parse(text).en;
        } catch {
          return text;
        }
      },
      width: "80px",
      align: "center",
    },
    {
      title: t("section"),
      dataIndex: "section",
      render: (text) => {
        try {
          return JSON.parse(text).en;
        } catch {
          return text;
        }
      },
      width: "80px",
      align: "center",
    },
    { 
      title: t("phoneNumber"), 
      dataIndex: "phone_number",
      width: "120px",
      align: "center",
    },
    { 
      title: t("gender"), 
      dataIndex: "gender",
      width: "80px",
      align: "center",
    },
    {
      title: t("tuitionFee"),
      dataIndex: "tuition_fee",
      render: (text) => parseFloat(text).toLocaleString("en-US"),
      width: "100px",
      align: "right",
    },
    {
      title: t("discountedStudents"),
      dataIndex: "tuition_discount",
      render: (text) => (
        <Tooltip
          title={
            t("discount") + `: ${parseFloat(text).toLocaleString("en-US")}`
          }
        >
          <span>{parseFloat(text).toLocaleString("en-US")}</span>
        </Tooltip>
      ),
      width: "100px",
      align: "right",
    },
    {
      title: t("totalPaid"),
      dataIndex: "total_paid",
      render: (text) => parseFloat(text).toLocaleString("en-US"),
      width: "100px",
      align: "right",
    },
    {
      title: t("remainingBalance"),
      dataIndex: "total_remaining",
      render: (text) => parseFloat(text).toLocaleString("en-US"),
      width: "100px",
      align: "right",
    },
  ];

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }
  const getCurrentAcademicYear = () => {
    const currentYear = new Date().getFullYear();
    return `${currentYear}-${currentYear + 1}`;
  };
  // Calculate statistics
  const stats = {
    totalStudents: filteredData.length,
    totalTuitionFee: totals.tuitionFee,
    totalPaid: totals.totalPaid,
    totalRemaining: totals.totalRemaining,
    averagePaid: filteredData.length > 0 ? totals.totalPaid / filteredData.length : 0,
    paymentCompletion: filteredData.length > 0 ? (totals.totalPaid / totals.tuitionFee) * 100 : 0,
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <style>{printStyles}</style>
      <Box
        className="print-container"
        sx={{
          direction: isRTL ? "rtl" : "ltr",
          textAlign: isRTL ? "right" : "left",
          padding: 2,
          marginBottom: 17,
          backgroundColor: "#f8f9fa",
          minHeight: "100vh",
          "@media print": {
            padding: 0,
            margin: 0,
            overflow: "visible !important",
            height: "auto !important",
            backgroundColor: "white !important",
          },
        }}
      >
        {/* Print Header */}
        <div className="print-header">
          <div
            style={{
              display: "flex",
              margin: "0 auto",
              padding: "0",
            }}
          >
            <div
              style={{
                flex: 1,
                textAlign: "right",
                marginRight: "40px",
              }}
            >
              <div
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  marginBottom: "10px",
                }}
              >
                {branchTitle}
              </div>

              <div style={{ fontSize: "16px", marginBottom: "15px" }}>
                ساڵی خوێندن ( {getCurrentAcademicYear()} )
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100px",
                marginLeft: "40px",
              }}
            >
              <img
                src={selectedImage}
                alt="School Logo"
                style={{
                  width: "100%",
                  height: "auto",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
          <hr
            style={{
              borderColor: "#000",
              margin: "20px 0",
              textAlign: "right",
            }}
          />
          <div
            className="print-title"
            style={{
              color: "red",
              fontSize: "40px",
              fontWeight: "bold",
            }}
          >
            تۆماری قوتابیان
          </div>
        </div>

        {/* Filters */}
        <Grid container spacing={2} mb={2} className="no-print">
          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              select
              label={t("class")}
              value={classFilter}
              onChange={(e) => setClassFilter(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="all">{t("allClasses")}</option>
              {[...Array(12).keys()].map((n) => (
                <option key={n + 1} value={n + 1}>
                  {t("class")} {n + 1}
                </option>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              select
              label={t("section")}
              value={sectionFilter}
              onChange={(e) => setSectionFilter(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="all">{t("allSections")}</option>
              {["A", "B", "C", "D", "E", "F", "G", "H", "I"].map((sec) => (
                <option key={sec} value={sec}>
                  {t("section")} {sec}
                </option>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              label={t("minPaid")}
              value={minPaid}
              onChange={(e) => setMinPaid(e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              fullWidth
              type="number"
              label={t("maxPaid")}
              value={maxPaid}
              onChange={(e) => setMaxPaid(e.target.value)}
            />
          </Grid>
        </Grid>

        {/* Print Button */}
        <Box textAlign="center" mb={2} className="no-print">
          <Button
            variant="contained"
            onClick={handlePrint}
            sx={{
              width: 200,
              fontWeight: "bold",
              backgroundColor: "#2e7d32",
              "&:hover": { backgroundColor: "#1b5e20" },
            }}
          >
            {t("page Print")}
          </Button>
        </Box>

        {/* Table */}
        <TableContainer
          component={Paper}
          sx={{
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
            overflow: "hidden",
            border: "1px solid #e9ecef",
            backgroundColor: "white",
            direction: isRTL ? "rtl" : "ltr",
            "@media print": {
              boxShadow: "0 1px 3px rgba(0,0,0,0.1) !important",
              border: "none !important",
              overflow: "visible !important",
              height: "auto !important",
              direction: isRTL ? "rtl" : "ltr",
              borderRadius: "8px !important",
            },
          }}
          className="table-container"
        >
          <Table sx={{ direction: isRTL ? "rtl" : "ltr" }}>
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.dataIndex || column.title}
                    sx={{
                      background: "#1e3a8a",
                      color: "#ffffff",
                      fontWeight: 700,
                      fontSize: "13px",
                      textAlign: column.align || (isRTL ? 'right' : 'center'),
                      textTransform: "uppercase",
                      letterSpacing: "0.8px",
                      padding: "16px 20px",
                      border: "none",
                      borderBottom: "2px solid #dee2e6",
                      width: column.width || "auto",
                      minWidth: column.width || "auto",
                      maxWidth: column.width || "auto",
                      "@media print": {
                        background: "#000080 !important",
                        color: "#ffffff !important",
                        fontSize: "20px !important",
                        border: "none !important",
                        borderBottom: "2px solid #dee2e6 !important",
                        width: column.width || "auto !important",
                        minWidth: column.width || "auto !important",
                        maxWidth: column.width || "auto !important",
                      },
                    }}
                  >
                    {column.title}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((row, index) => (
                <TableRow
                  key={row.id}
                  hover
                  sx={{ "&:last-child td": { borderBottom: 0 } }}
                >
                  {columns.map((column) => (
                    <TableCell
                      key={column.dataIndex || column.title}
                      sx={{
                        border: "none",
                        borderBottom: "1px solid #f0f0f0",
                        fontSize: "20px",
                        padding: "16px 20px",
                        textAlign: column.align || (isRTL ? 'right' : 'left'),
                        verticalAlign: "middle",
                        transition: "all 0.2s ease",
                        width: column.width || "auto",
                        minWidth: column.width || "auto",
                        maxWidth: column.width || "auto",
                        "&:hover": {
                          backgroundColor: "#f8f9fa",
                          transform: "translateY(-1px)",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                        },
                        "@media print": {
                          padding: "16px 20px !important",
                          border: "none !important",
                          borderBottom: "1px solid #f0f0f0 !important",
                          fontSize: "24px !important",
                          width: column.width || "auto !important",
                          minWidth: column.width || "auto !important",
                          maxWidth: column.width || "auto !important",
                        },
                      }}
                    >
                      {column.render
                        ? column.render(row[column.dataIndex], row, index)
                        : row[column.dataIndex]}
                    </TableCell>
                  ))}
                </TableRow>
              ))}

              {/* Total Row */}
              <TableRow
                className="total-row"
                sx={{
                  backgroundColor: "#e3f2fd",
                  "@media print": {
                    backgroundColor: "#e3f2fd !important",
                  },
                }}
              >
                <TableCell
                  colSpan={6}
                  align="right"
                  sx={{ 
                    background: "#ffffff",
                    color: "#2c3e50",
                    fontWeight: 700,
                    fontSize: "20px",
                    padding: "20px",
                    border: "none",
                    borderTop: "3px solid #2196f3",
                    position: "relative",
                    "@media print": {
                      background: "#ffffff !important",
                      color: "#2c3e50 !important",
                      border: "none !important",
                      borderTop: "3px solid #2196f3 !important",
                      fontSize: "20px !important",
                    },
                  }}
                >
                  {t("total")}
                </TableCell>
                <TableCell sx={{ 
                  background: "#ffffff",
                  color: "#2c3e50",
                  fontWeight: 700,
                  fontSize: "16px",
                  padding: "20px",
                  border: "none",
                  borderTop: "3px solid #2196f3",
                  "@media print": {
                      background: "#ffffff !important",
                      color: "#2c3e50 !important",
                    border: "none !important",
                    borderTop: "3px solid #2196f3 !important",
                    fontSize: "16px !important",
                  },
                }}>
                  {totals.tuitionFee.toLocaleString("en-US")}
                </TableCell>
                <TableCell sx={{ 
                  background: "#ffffff",
                  color: "#2c3e50",
                  fontWeight: 700,
                  fontSize: "16px",
                  padding: "20px",
                  border: "none",
                  borderTop: "3px solid #2196f3",
                  "@media print": {
                      background: "#ffffff !important",
                      color: "#2c3e50 !important",
                    border: "none !important",
                    borderTop: "3px solid #2196f3 !important",
                    fontSize: "16px !important",
                  },
                }}>
                  {totals.tuitionDiscount.toLocaleString("en-US")}
                </TableCell>
                <TableCell sx={{ 
                  background: "#ffffff",
                  color: "#2c3e50",
                  fontWeight: 700,
                  fontSize: "16px",
                  padding: "20px",
                  border: "none",
                  borderTop: "3px solid #2196f3",
                  "@media print": {
                      background: "#ffffff !important",
                      color: "#2c3e50 !important",
                    border: "none !important",
                    borderTop: "3px solid #2196f3 !important",
                    fontSize: "16px !important",
                  },
                }}>
                  {totals.totalPaid.toLocaleString("en-US")}
                </TableCell>
                <TableCell sx={{ 
                  background: "#ffffff",
                  color: "#2c3e50",
                  fontWeight: 700,
                  fontSize: "16px",
                  padding: "20px",
                  border: "none",
                  borderTop: "3px solid #2196f3",
                  "@media print": {
                      background: "#ffffff !important",
                      color: "#2c3e50 !important",
                    border: "none !important",
                    borderTop: "3px solid #2196f3 !important",
                    fontSize: "16px !important",
                  },
                }}>
                  {totals.totalRemaining.toLocaleString("en-US")}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </LocalizationProvider>
  );
};

export default GetStudentReport;
